import Vue from 'vue'

let EventBus = new Vue()
EventBus.constants = {
  LANGUAGE_CHANGED: 'LANGUAGE_CHANGED',
  NAVIGATION_CLASS_CHANGED: 'NAVIGATION_CLASS_CHANGED',
  HIDE_LOADING_SCREEN: 'HIDE_LOADING_SCREEN',
  SHOW_LOADING_SCREEN: 'SHOW_LOADING_SCREEN',
  HIDE_NAVIGATION: 'HIDE_NAVIGATION'
}

export default EventBus